


























































import {
  PropType,
  computed,
  defineComponent,
} from '@nuxtjs/composition-api';
import { SfPrice } from '@storefront-ui/vue';
import SvgImage from '~/components/General/SvgImage.vue';
import JetUiButton from '~/components/JetUi/atoms/JetUiButton/JetUiButton.vue';
import Warning from '~/components/JetUi/atoms/Warning/Warning.vue';
import type { Cart } from '~/composables';
import cartGetters from '~/modules/checkout/getters/cartGetters';

export default defineComponent({
  name: 'OrderInfo',
  components: {
    JetUiButton,
    SvgImage,
    SfPrice,
    Warning,
  },
  props: {
    cart: {
      type: Object as PropType<Cart>,
      required: true,
    },
    paymentMethod: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const shippingAddress = computed(() => props.cart.shipping_addresses?.[0]);
    const totals = computed(() => cartGetters.getTotals(props.cart));
    const discount = computed(() => -cartGetters.getDiscountAmount(props.cart));

    const openOrders = () => {
      window.location.href = '/customer/order-history';
    };

    return {
      shippingAddress,
      totals,
      discount,
      openOrders,
    };
  },
});
